import React, {FC} from 'react';
import block from 'bem-cn-lite';

import {NavigationSectionType} from 'units/navigation/models';
import {ServiceIcon} from 'components/ServiceIcon';

import './NavigationIcon.scss';

const b = block('navigation-icon');

export enum NavigationItemTypes {
    Products = 'products',
}

export const NavigationItemsExtendedEnum = {...NavigationSectionType, ...NavigationItemTypes};
export type NavigationItemsExtendedType = NavigationSectionType | NavigationItemTypes;

export interface NavigationIconProps {
    type: NavigationItemsExtendedType;
    iconProps: {
        name?: string;
        src?: string;
    };
}

export const NavigationIcon: FC<NavigationIconProps> = ({type, iconProps}) => {
    switch (type) {
        case NavigationItemsExtendedEnum.Services:
            return <ServiceIcon className={b({svg: true})} size={16} {...iconProps} />;
        case NavigationItemsExtendedEnum.Products:
            return <img className={b({img: true})} {...iconProps} alt="navigation-icon" />;
        default:
            return null;
    }
};

export default NavigationIcon;
